export default __webpack_public_path__ + "static/media/events_bg-min.4e5baec8.jpg";